<template>
  <div class="TravelInsuranceTypeForm">
    <h2 class="gl_form-title">
      {{ t(`copy_travel_insurance-type_form-title-${forWhom}`, answers.forWhomPeople) }}
    </h2>

    <RadioButtonGroup
      id="type"
      :value="insuranceType"
      :options="insuranceOptions"
      v-model="insuranceType"
      :rules="[validationRules.required]"
    />
  </div>
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import RadioButtonGroup from '@/modules/core/components/ui/RadioButtonGroupComponent.vue'
import type TravelConfigurations from '@/modules/travel/common/models/APP/TravelConfigurations'
import { useRules } from '@/modules/core/composables/useRulesComposable'
import type TravelRaterAnswers from '../../models/APP/TravelRaterAnswers'

const { t } = useI18n()
const { required } = useRules()

defineExpose({ triggerSubmit })
interface PropsInterface {
  nextForm: String[]
  answers: TravelRaterAnswers
  configurations: TravelConfigurations
}
const props = withDefaults(defineProps<PropsInterface>(), {})

const forWhom = computed(() => props.answers.forWhom ?? 'me')
const insuranceOptions = computed(() => props.configurations.insuranceTypesOptions)
const insuranceTypes = computed(() => props.configurations.insuranceTypes)
const insuranceType = ref(
  props.answers.insuranceType
    ? String(props.answers.insuranceType)
    : props.configurations.defaultInsuranceType
)

const validationRules = {
  required
}

function getNextStep() {
  if (insuranceTypes.value.studyAbroad.id === insuranceType.value) {
    return props.nextForm[1] //'SportInsurance'
  }

  return props.nextForm[0] //'TravelDuration'
}

function triggerSubmit() {
  const page = getNextStep()
  const answers: any = {
    insuranceType: Number(insuranceType.value)
  }

  if (answers.insuranceType !== props.answers.insuranceType) {
    answers.destinationType = undefined
    answers.sportInsurance = undefined
  }

  return { page, answers }
}
</script>

<style lang="scss" scoped>
.gl_form-title {
  margin-bottom: $spacing-xl;
}
</style>
